import type { StorageEnvelope } from './types';

export function parseEnvelope<T = unknown>(raw: string): StorageEnvelope<T> | null {
  try {
    const obj = JSON.parse(raw) as StorageEnvelope<T>;
    const isValidEnvelope =
      obj !== null &&
      typeof obj === 'object' &&
      typeof obj._exp === 'number' &&
      typeof obj._ts === 'number' &&
      'value' in obj;
    return isValidEnvelope ? obj : null;
  } catch {
    return null;
  }
}

export const isExpired = (env: StorageEnvelope): boolean => Date.now() > env._exp;

export function createEnvelope<T = unknown>(value: T, expireAtEpochMs: number): StorageEnvelope<T> {
  return {
    value,
    _ts: Date.now(),
    _exp: expireAtEpochMs,
  };
}
